module.exports = __webpack_public_path__ + "static/media/not-found-illustration.33f3d00f.svg";